<template>
    <v-container id="certificadoalumno-ivt">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    dark
                    color="success"
                    class="alineacentro DatosMatriculado"
                  >
                    <strong>LISTADO DE ASISTENCIA POR ESTUDIANTE</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <selector-alumno :habilitado="false" ref="selalu" @selAlumno="asignaalumnofiltro" :nivel=4>
                  </selector-alumno>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="8" lg="8">
                  <v-select
                    v-model="filtros.idcarrera"
                    :items="listacarreras"
                    label="Carrera"
                    item-text="carrera"
                    item-value="idcarrera"
                    height="20px"
                  />
                </v-col>
                <v-col cols="12" md="4" lg="4">
                  <v-select
                    v-model="filtros.anio"
                    :items="listaanios"
                    label="Año"
                    item-text="anio"
                    item-value="anio"
                    height="20px"
                  />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="4" lg="4">
                  <v-checkbox v-model="filtros.anuales" label="Asig. Anuales"></v-checkbox>
                </v-col>
                <v-col cols="12" md="4" lg="4">
                  <v-checkbox v-model="filtros.cuat1" label="Asig. Cuat 1"></v-checkbox>
                </v-col>
                <v-col cols="12" md="4" lg="4">
                  <v-checkbox v-model="filtros.cuat2" label="Asig. Cuat 2"></v-checkbox>
                </v-col>
              </v-row>
              <v-row class="text-center" v-if="filtros.idalumno!=null && filtros.idalumno!=0">
                <v-col cols="12" md="4" lg="4" class="alineaderecha">
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="success"
                    title="Imprimir"
                    @click="ImprimirListado"
                    :disabled="!permisolectura"
                  >
                    <v-icon dark> mdi-printer </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ mensajetitulo }}
          </v-card-title>
          <v-card-text>
            {{ mensajecuerpo }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
                color="green darken-1"
                text
                @click="
                dialogmensaje = false;
                if (mensajehome === true) {
                    $router.push('Home');
                }
                "
            >
                Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
          fluid
          class="full-height"
          style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
          >
            <v-col class="elementocentrado">
              <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
import SelectorAlumno from "../../components/SelectorAlumno.vue";
export default {
  name: "listadoasistenciaxalumno",
  components: {
    ConfirmDlg: ConfirmDlg,
    SelectorAlumno: SelectorAlumno
  },
  data() {
    return {
      loading: false,
      usuario: '',
      permisolectura: false,
      permisoescritura: false,
      idrol: 0,
      roles: [],
      nromodulo: 25,
      dialogmensaje: false,
      mensajetitulo: '',
      mensajecuerpo: '',
      mensajehome: false,
      listacarreras: [],
      listaanios: [],
      filtros: {
        idalumno: 0,
        alumno: '',
        idcarrera: 0,
        anio: 0,
        anuales: true,
        cuat1: true,
        cuat2: true,
        usuario: ''
      },
    };
  },
  mounted() {
    this.loading = true;
    this.roles=[];
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    var rolesuser = localStorage.getItem("rolesuserid").split(',');
    rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
    });
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
        this.loading = false;
        this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
        this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
        this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 3).length > 0 ? true : false;
        this.filtros= {
            idalumno: 0,
            alumno: '',
            idcarrera: 1,
            anio: (new Date()).getFullYear(),
            anuales: true,
            cuat1: true,
            cuat2: true,
            usuario: this.usuario
        };
        this.listaanios=[];
        var i=0;
        var anioactual= (new Date()).getFullYear();
        for(i=2023;i<=anioactual+1;i++){
          this.listaanios.push({anio: i});
        }
        this.filtros.anio= anioactual;
        this.loading= false;
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    ImprimirListado () {
      this.loading = true;
      axios.post("reportes/GetReporte",
        {idreporte: 19, formato: 'PDF',nromodulo: parseInt(this.nromodulo), usuario: this.usuario.toString(), listaparametros: [{ orden: 1, nombre: "idcarrera", valor: this.filtros.idcarrera.toString()}, { orden: 2, nombre: "idalumno", valor: this.filtros.idalumno.toString()},{ orden: 3, nombre: "anio", valor: this.filtros.anio.toString()},{ orden: 4, nombre: "anuales", valor: this.filtros.anuales===true ? "1" : "0"},{ orden: 5, nombre: "cuat1", valor: this.filtros.cuat1===true ? "1" : "0"},{ orden: 6, nombre: "cuat2", valor: this.filtros.cuat2===true ? "1" : "0"},{ orden: 7, nombre: "alumno", valor: this.filtros.alumno}] },{ headers: { "Content-Type": "application/json" }})
        .then((result) => {
          this.loading = false;
          if (result.data.toString().startsWith("Error") === false) {
            window.open(result.data, "_blank");
          } else {
            this.MostrarMensaje("Error", result.data, false);
          }
      }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
      });
    },
    asignaalumnofiltro (value) {
        this.filtros.idalumno = value != null ? value.idalumno : 0;
        this.filtros.alumno= value != null ? '('+value.nrodoc+') ' + value.apellido + ' ' + value.nombre : '';
        if(this.filtros.idalumno!=0) {
          axios.get('alumno/carrerasalumno/0/ /' + this.filtros.idalumno + '/0').then((result) => {
            if(result.data.resultado===0) {
              this.listacarreras = result.data.datos;
              if(this.listacarreras.length>0) {
                this.filtros.idcarrera=this.listacarreras[0].idcarrera;
              }
            }else{
              this.loading = false;
              this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje('Error', error, false);
          });
        }
    },
    },
};
</script>
<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.fullpantalla{
    height: 100% !important;
    width: 100% !important;
}

.letraroja {
  color: red;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>
